const DEFAULT_SERVICES = {
    COORDS: {
        id: 'coords',
        onlyIfLayersVisible: [],
        type: 'WFS',
        url: 'https://cz-services.tmapserver.cz/services/mapserver/common/tools/coord/gservice?&service=WFS&request=GetFeature&outputFormat=json&version=1.1.0&srsName=EPSG:5514&propertyName=x,y,xjtsk,yjtsk,lon,lat',
        properties: {
            id: '',
            fieldsPath: 'features',
        },
        isAuth: false,
    },
};
export const deriveInfoStateFromConfig = (config) => {
    if ((!config?.services || config.services.length === 0) && !config?.coordsInfo) {
        return null;
    }
    const services = config?.services.map((service) => ({
        ...service,
        onlyIfLayersVisible: service.onlyIfLayersVisible ?? [],
    })) || [];
    if (config?.coordsInfo) {
        services.push(DEFAULT_SERVICES.COORDS);
    }
    return { services, point: null, data: {} };
};
//# sourceMappingURL=deriveInfoStateFromConfig.js.map